import React from "react";

const Locations = () => {
  const locations = [
    {
      id: 1,
      brand: "Biryani By Kilo",
      brandColor: "text-red-600",
      image: "/images/store_page_bbk.png",
      address: "In - 191 Hessa St - Al Barsha - Al Barsha 3",
      area: "Dubai - United Arab Emirates",
      timing: "Get Directions",
      googleMapsUrl: "https://maps.app.goo.gl/HCkwTZ9Hr1xrJusD8",
      phone: "Phone: +971-4-1234567",
      location: "+971 4 572 3681",
      hours: "Timing: 11 AM - 11:30 PM",
      delivery: "",
    },
    {
      id: 2,
      brand: "Furn Beaino",
      brandColor: "text-orange-600",
      image: "/images/store_page_furn.png",
      address: "Outlets in Business Bay and Hessa Street",
      area: "Delivery and take-out",
      timing: "",
      googleMapsUrl: "",
      phone: "",
      location: "",
      hours: "Delivery orders accepted.",
      delivery: "Email: info@furnbeaino.ae",
    },
    {
      id: 3,
      brand: "Blue Tokai",
      brandColor: "text-blue-600",
      image: "/images/store_page_blue_tokai.png",
      address:
        "Burjuman Mall, Burjuman - Shop L1/10, 1st Floor, Burjuman Centre - Mankhool - Dubai",
      area: "Dubai - United Arab Emirates",
      timing: "Get Directions",
      googleMapsUrl: "https://maps.app.goo.gl/cMSb3dTW2kkgv6jN9",
      phone: "Phone: +971-5-63116256",
      location: "",
      hours: "Timing: 08 AM - 11:00 PM",
      delivery: "",
    },
    {
      id: 4,
      brand: "Mr. Brown",
      brandColor: "text-yellow-600",
      image: "/images/store_page_brown.jpg",
      address: "Outlets in Business Bay and Hessa Street",
      area: "Delivery and take-out",
      timing: "",
      googleMapsUrl: "",
      phone: "",
      location: "",
      hours: "Delivery orders accepted.",
      delivery: "",
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="bg-white py-16 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="breadcrumb mb-8">
            <span className="text-gray-500">Ambrosia Home</span>
            <span className="text-gray-500 mx-2">/</span>
            <span className="text-orange-600 font-semibold">
              Store Locations
            </span>
          </div>

          <div>
            <p className="text-orange-600 font-semibold uppercase tracking-wide mb-4">
              FIND US NEARBY
            </p>
            <h1 className="text-4xl font-bold text-red-600 mb-8">
              Store Locations
            </h1>
          </div>
        </div>
      </div>

      {/* Store Locations Grid */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {locations.map((location) => (
            <div
              key={location.id}
              className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              {/* Store Image */}
              <div className="h-64 overflow-hidden">
                <img
                  src={location.image}
                  alt={location.brand}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* Store Info */}
              <div className="p-6">
                <h3 className={`text-xl font-bold mb-4 ${location.brandColor}`}>
                  {location.brand}
                </h3>

                <div className="space-y-3 text-sm text-gray-600">
                  {location.address && (
                    <p className="font-semibold text-gray-900">
                      {location.address}
                    </p>
                  )}

                  {location.area && <p>{location.area}</p>}

                  {location.timing && location.googleMapsUrl && (
                    <a
                      href={location.googleMapsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline cursor-pointer hover:text-blue-800 transition-colors duration-200"
                    >
                      {location.timing}
                    </a>
                  )}
                  {location.timing && !location.googleMapsUrl && (
                    <p className="text-gray-400">{location.timing}</p>
                  )}

                  {location.phone && <p>{location.phone}</p>}

                  {location.location && <p>{location.location}</p>}

                  {location.hours && <p>{location.hours}</p>}

                  {location.delivery && (
                    <p className="text-xs leading-relaxed">
                      {location.delivery}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Locations;
